import { HOSTED_DOMAIN } from "@labs/shared/data/deploymentConstants.ts";

export const getEmailLambdaUrl = (): string => {
  const regex = new RegExp(`(.*)-(.*).${HOSTED_DOMAIN}`);
  const [, stackPrefix, envName] = regex.exec(window.location.hostname) || [];
  return `https://${stackPrefix}-${envName}-labs-email-lambda.${HOSTED_DOMAIN}/email`;
};
